import { useStoreContext } from './useStoreContext'

export const useMixMatchEnabled = () => {
  const store = useStoreContext()
  return store.mixMatchEnabled
}
